<script>
export default {
    name: "ConsultantItemEditForm",

    props: {

        consultantItem: Object,
        showModal: Boolean,
        items: Array
    },

    methods: {

        fetchSearchedItems() {

            if(!this.consultantItem.itemName) return;
            this.$root.loading = true;
            this.$http.get(`MasterData/GetNotConsultantItemsSearch?SearchText=${this.consultantItem.itemName}`)
                .then(response => {
                    this.items = response.data;
                    this.$root.loading = false;
                }).catch(() => { this.$root.loading = false; });
        },

        updateData() {

            this.$root.loading = true;
            this.$http.post(`MasterData/ConsultantItems`, this.consultantItem).then(response => {
                this.$root.loading = false;
                window.Swal.fire({ type: 'success', title: response.data});
            }).catch(() => { this.$root.loading = false; });
        },
    },
}
</script>
<template>
    <tail-modal :show="showModal" dimension="w-8/12 h-auto">
      <template v-slot:title>
        <h5>Edit Consultant Item</h5>
      </template>
      <template v-slot:modal-body>
            <div class="flex flex-wrap">
                <div class="w-1/4 p-2">
                    <label for="grid-item-select-edit" class="label-control">Service/Item:</label>
                    <input type="text" placeholder="press enter to search" v-on:keyup.enter="fetchSearchedItems" v-model="consultantItem.itemName" id="grid-item-select-edit" class="input-control input-sm text-xs">
                </div>
                <div class="w-1/4 p-2 pt-4">
                    <select id="grid-item" v-model="consultantItem.itemId" class="input-sm input-control text-xs mt-4">
                        <option v-for="(item, idx) in items" :value="item.itemID" :key="idx">{{ item.itemName }}</option>
                    </select>
                </div>
                <div class="w-1/4 p-2">
                    <label for="grid-description-edit" class="label-control">Description:</label>
                    <textarea  id="grid-description-edit" v-model="consultantItem.description" class="input-control input-sm text-xs" cols="3" rows="1"></textarea>
                </div>
                <div class="w-1/6 p-2">
                    <label for="grid-status-edit" class="label-control mt-5">Active <input type="checkbox" v-model="consultantItem.status" id="grid-status-edit"></label>
                </div>
            </div>
      </template>
      <template v-slot:modal-footer>
        <button class="btn-danger btn-sm text-xs mr-4" @click="$emit(`closeModal`)"><i class="fa fa-times"></i> Cancel</button>
        <button class="btn-primary btn-sm text-xs" @click.prevent="updateData"><i class="fa fa-save"></i> Update</button>
      </template>
    </tail-modal>
</template>
